import api from "@/api";
import { MagazineModel, NoticeModel, PageModel, PaginationModel } from "../types";

export default class MagazineApi {
    static async list() {
        return await api.get(`magazine`);
    }

    static async insert(data: FormData){
        return await api.post(`magazine`, data);
    }

}